module.exports = __webpack_public_path__ + "img/blueSapphireRings.df0f7c0.webp";